import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const r = a((e, i) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: i,
    ...e,
    image: (l) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zM19.75 16.906c-.117 2.198-1.553 3.264-3.58 3.264-2.373 0-3.844-1.594-3.844-4.336 0-2.772 1.494-4.4 3.856-4.4 2.056 0 3.504 1.148 3.574 3.234h-1.863c-.094-1.113-.721-1.7-1.694-1.7-1.236 0-1.974 1.003-1.974 2.83 0 1.817.72 2.82 2.021 2.82.967 0 1.535-.68 1.623-1.712z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "VitaminCIcon";
export {
  r as VitaminCIcon,
  r as default
};
//# sourceMappingURL=index.js.map
